import { Injectable } from '@angular/core';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { FiltersStorageService } from './filters-storage.service';

@Injectable({
    providedIn: 'root'
})
export class FiltersHelperService {
    constructor(
        private filtersStorageService: FiltersStorageService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {}

    public mergeQueryParam<T>(filter: T, urlName: string, filterParamName = 'filter'): void {
        const expressionParam: Params = {
            [filterParamName]: JSON.stringify(filter, (key, value) => {
                if (value === null) {
                    return undefined;
                }

                return value;
            })
        };

        this.router
            .navigate([], {
                relativeTo: this.activatedRoute,
                queryParams: expressionParam,
                queryParamsHandling: 'merge'
            })
            .then(() => this.filtersStorageService.setFilterUrl(urlName, this.router.url));
    }

    public restoreFilter<T>(filterKey: string, filterName: string = 'filter') {
        let value = this.activatedRoute.snapshot.queryParamMap.get(filterName);
        if (!value) {
            value = this.filtersStorageService.getFilterValue(filterKey, filterName);
        }

        if (value) {
            return <T>JSON.parse(value);
        }

        return null;
    }
}
